/* hs-eslint ignored failing-rules */
/* eslint-disable react/no-children-prop */

import PropTypes from 'prop-types';
import UIListingPage from 'UIComponents/page/UIListingPage';
import Header from './Header';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Page({
  children
}) {
  return /*#__PURE__*/_jsx(UIListingPage, {
    pageLayout: "max-width",
    children: children,
    headerComponent: /*#__PURE__*/_jsx(Header, {})
  });
}
Page.propTypes = {
  children: PropTypes.node
};